// ContactForm.js

import React from 'react'
import styles from "./ContactForm.module.scss"
import Form from '../LowLevel/Form/Form';

export default function ContactForm({ setFormOpen, setMessage }) {
  const contactFields = [
    [
      { type: "text", name: "name", label: "Name", col: "col-lg-6", style: { marginBottom: '0.5rem' } },
      { type: "email", name: "email", label: "Email", col: "col-lg-6", style: { marginBottom: '0.5rem' } }
    ],
    [{ type: "textarea", name: "message", label: "Message", col: "col-lg-12", style: { marginBottom: '1rem' } }],
  ];


  return (
    <div className={styles.contactParent} id="contact">
      <h2>Ready to Scale Smarter?</h2>
      <p>Let’s connect and talk about how Altra Edge can help you grow your business and meet your performance goals. </p>
      <div className={`row ${styles.contactBody}`}>
        <div className='col-md-6 col-12 pe-md-3'>
          <Form value={contactFields} setFormOpen={setFormOpen} setMessage={setMessage}/>
        </div>
        <div className='col-md-6 col-12 d-flex ps-md-3 flex-column justify-content-center'>
          <div className={styles.contactLine1}>
            Give Your Brand the Edge it Needs
          </div>
          <div className={styles.contactLine2}>
            #GetTheEdge
          </div>
        </div>
      </div>
    </div>
  )
}
